import { Button, SimpleListTable } from '@fullscreendigital/carrefour-dex-fe'
import { getLocationChildrenRows } from '../helpers'
import { Grid } from '@mui/material'
import { AddActionIcon, DeleteActionIcon, EditActionIcon } from 'icons'
import { ChildListItem } from 'components/location/interfaces'
import { usePermissions } from 'hooks'
import { roles } from 'components/location/constants'

interface LocationDetailsProps {
  parentName: string
  childList: ChildListItem[]
  level: number
  addChild: (parentId: number) => void
  editItem: (rowId: number) => void
  deactivateItem: (rowId: number) => void
}

const LocationDetails = (props: LocationDetailsProps) => {
  const { parentName, childList, level, addChild, editItem, deactivateItem } = props

  const { canCreate, canEdit, canDelete } = usePermissions(roles)

  return (
    <Grid>
      {!!childList?.length && (
        <Grid item xs={12}>
          <SimpleListTable
            rows={getLocationChildrenRows(
              parentName,
              childList,
              level,
              addChild,
              editItem,
              deactivateItem
            )}
            rowActions={
              canEdit || canCreate || canDelete
                ? [
                    canEdit && {
                      label: 'Edit',
                      labelColor: 'white',
                      typographyVariant: 'medium',
                      backgroundColor: '#16a085',
                      desktopIcon: <EditActionIcon />,
                      onClick: (_, rowId) => editItem(+rowId)
                    },
                    canCreate && {
                      label: 'Add child',
                      labelColor: 'white',
                      typographyVariant: 'medium',
                      backgroundColor: '#0970E6',
                      desktopIcon: <AddActionIcon />,
                      onClick: (e, row) => addChild(+row)
                    },
                    canDelete && {
                      label: 'Change status',
                      labelColor: 'white',
                      typographyVariant: 'medium',
                      backgroundColor: '#d9534f',
                      desktopIcon: <DeleteActionIcon />,
                      onClick: (_e, rowId) => deactivateItem(+rowId)
                    }
                  ]
                : []
            }
            rowActionsWidth="370px"
          />
        </Grid>
      )}
    </Grid>
  )
}

export default LocationDetails
